export const tableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
	  {
      label: '名称',
      prop: 'circleName',
      overHidden: true,
      width: 200,
    },
    {
      label: '作者',
      prop: 'createdByName',
      solt: true
    },
    {
      label: '文章',
      prop: 'postCount',
      solt: true,
      sortable: true
    },
    {
      label: '订阅',
      prop: 'memberCount',
      sortable: true
    },
    {
      label: '状态',
      prop: 'activeText'
    },
    {
      label: '顺序',
      prop: 'sort',
      sortable: true
    },
	  {
      label: '创建时间',
      prop: 'createdTime',
      width: 180,
      sortable: true
    },
	  {
      label: '更新时间',
      prop: 'updatedTime',
      width: 180,
      sortable: true
    }
  ]
}

export const isPublicOptions = [
  {label: '是', value: 1},
  {label: '否', value: 0}
]

export const isActiveOptions = [
  {label: '正常', value: 1},
  {label: '已关闭', value: 0}
]

export const columnMemberOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  menu: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
    // {
    //   label: 'ID',
    //   prop: 'id'
    // },
	  {
      label: 'Full Name',
      prop: 'name'
    },
    {
      label: '手机号',
      prop: 'phoneNumber'
    },
    {
      label: '地区',
      prop: 'location'
    },
	  {
      label: '公司',
      prop: 'company'
    },
    {
      label: '行业',
      prop: 'industry'
    },
	  {
      label: '订阅时间',
      prop: 'joinedTime'
    }
  ]
}

export const circleNoticeOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
    {
      label: 'ID',
      prop: 'id'
    },
	  {
      label: '内容',
      prop: 'content'
    },
    {
      label: '发布者',
      prop: 'createdName'
    },
    {
      label: '发布时间',
      prop: 'createdTime'
    },
    {
      label: '状态',
      prop: 'activeText'
    }
  ]
}
